import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface ChoiceModalProps {
  customLogoWidth?: string;
}

// Props are not used, but are required for proper media rules
const styles: ComponentStylesProps<ChoiceModalProps> = {
  modal: {
    boxSizing: 'border-box',
    padding: '5.2rem 6.4rem 4rem',
    minHeight: '20rem',
    maxHeight: '85vh',
    maxWidth: '77rem',
    [breakpoints.lg.down]: {
      padding: '5.2rem 2rem 4rem',
      width: '80%',
    },
    '@media(max-width: 450px)': {
      width: '90%',
    },
  },
  title: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    letterSpacing: '0.02rem',
    marginBottom: '3.5rem',
    marginTop: '2rem',
    textAlign: 'center',
  },
  buttonsBar: {
    display: 'flex',
    gap: '2rem',
    justifyContent: 'center',
    marginBottom: '6rem',
    '@media(max-width: 854px)': {
      flexDirection: 'column',
      gap: '3rem',
    },
  },
  activeButton: {
    border: `0.2rem solid ${colors.blue[600]}`,
    minWidth: '18rem',
    '@media(max-width: 854px)': {
      width: '100%',
    },
  },
  inactiveButton: {
    color: colors.blue[600],
    minWidth: '18rem',
    '@media(max-width: 854px)': {
      width: '100%',
    },
  },

  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: ({ customLogoWidth }) => ({
    width: customLogoWidth || '20rem',
  }),
};

const createStyles = createUseStyles(styles);
export { createStyles };
